import { useMemo } from "react";
import {
    GroupType,
    NameAssertion,
    type RelationshipFieldGroup,
    ResponseItemType,
    useMetadataQuery,
} from "@/entities/form-metadata";

export interface FamilyExactnessConfig {
    /** Set of relation keys (lowercase, e.g. "father") where GivenName has showExactness: false */
    givenNameDisabled: Set<string>;
    /** Set of relation keys where Surname has showExactness: false */
    surnameDisabled: Set<string>;
}

export const useFamilyFieldsWithExactnessDisabled = (): FamilyExactnessConfig => {
    const { data: formMetadata } = useMetadataQuery();

    return useMemo(() => {
        const givenNameDisabled = new Set<string>();
        const surnameDisabled = new Set<string>();

        for (const entry of formMetadata.fieldGroupsAndFeatureContainers) {
            if (entry.type !== ResponseItemType.FieldGroup) continue;
            if (entry.groupType !== GroupType.FamilyMember) continue;

            const familyGroup = entry as RelationshipFieldGroup;
            for (const fieldset of familyGroup.fieldsets) {
                const relationKey = fieldset.relation.toLowerCase();
                for (const field of fieldset.fields) {
                    if (field.assertion === NameAssertion.GivenName && field.features.showExactness === false) {
                        givenNameDisabled.add(relationKey);
                    }
                    if (field.assertion === NameAssertion.Surname && field.features.showExactness === false) {
                        surnameDisabled.add(relationKey);
                    }
                }
            }
        }

        return { givenNameDisabled, surnameDisabled };
    }, [formMetadata.fieldGroupsAndFeatureContainers]);
};
